export default __webpack_public_path__ + "static/media/logo1.e56eb61d.png";